// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Func = /** @class */ (function () {
    function Func(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Func.prototype, "accountSwitch", {
        /**
         * func_accountSwitch 参数
         */
        get: function () {
            var func_accountSwitch = this.adapter.getStore().func_accountSwitch;
            return func_accountSwitch;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Func.prototype, "downloadGuide", {
        /**
         * func_downloadGuide 参数
         */
        get: function () {
            var func_downloadGuide = this.adapter.getStore().func_downloadGuide;
            return func_downloadGuide;
        },
        enumerable: false,
        configurable: true
    });
    return Func;
}());
export { Func };
